import React from "react";
import { Grid } from "@mui/material";
import Stats from "../card_statistics/Stats";

function CardStats() {
  return (
    <React.Fragment>
      <Grid
        container
        spacing={4}
        sx={{
          color: "success.main",
          justifyContent: "center",
        }}
      >
        <Grid item xs={9}>
          <Stats />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default CardStats;
